export const enum NextBehavior {
  Linear = 'Linear',
  SkipToLast = 'SkipToLast',
}
